<div class="m-1" *ngIf="!hidePayment && payment" [ngSwitch]="payment.Status">
  <div class="kp-message kp-message-success mx-2" *ngSwitchCase="3">
    <div class="pointer float-left f-white" (click)="close()"><i class="fa fa-times"></i></div>
    <h5>پرداخت با موفقیت انجام شد.</h5>
    <p class="fs-sm">شماره پیگیری : <span>{{payment?.Token}}</span></p>
    <ng-content select="[successTemplate]"></ng-content>
  </div>
  <ng-container *ngSwitchCase="0">
    <div *ngIf="payment.Provider!==PaymentProvider.Manual" class="kp-message orange-bg f-white mx-2">
      <div class="pointer float-left f-white" (click)="close()"><i class="fa fa-times"></i></div>
      <h4>پرداخت تکمیل نشد.</h4>
      اگر مبلغی از حساب شما کسر شده باشد براساس فرایند بانک عامل شما به کارت شما بازگردانده می‌شود
      <button class="btn btn-primary" (click)="retry()">اقدام مجدد</button>
    </div>

    <ng-container *ngIf="payment.Provider===PaymentProvider.Manual && !payment.RemindDate">
      <div class="kp-message kp-message-info m-0">
        <div class="pointer float-left f-white" (click)="close()"><i class="fa fa-times"></i></div>
        <h5>اطلاعات پرداخت شما ثبت شد.</h5>
        <p class="mb-0">
          چهار رقم آخر کارت شما : <span class="fw-bold">{{payment?.Token}}</span>
        </p>
        <div>
          مبلغ <b class="fs-xl">{{payment.Amount*10|number}} ریال</b> به کارت زیر واریز نمایید.
          <div class="kp-message kp-message-success text-center my-2 mx-1">
            <span class="fw-bold fs-xl ff-sans-serif" dir="ltr" copy
              message="شماره کارت کپی شد">6104-3388-0145-4436</span>
            <br />
            <span class="fs-lg">شرکت «کاوشگر کیان <b>کارپیشه</b>»</span>
            <br />
            <span class="fs-sm lh-1">جهت کپی بر روی شماره کارت کلیک کنید</span>
          </div>
        </div>
        <p>1 ساعت پس از واریز وجه سرویس شما فعال خواهد شد.</p>
        <ng-content select="[successTemplate]"></ng-content>
        <!-- <br />
          <p>لطفا در صورتی که هنوز واریز وجه انجام نشده، تا پایان امروز اقدام بفرمایید، در غیر این صورت مجددا فرم را ارسال
            کنید. </p> -->
      </div>
      <div class="text-center">
        <a class="btn btn-link f-blue p-0" (click)="manualModal.open()">
          <i class="fa fa-mouse-pointer ml-1"></i>4رقم آخر کارت رو اشتباه ثبت کردم
        </a>
        <a class="btn btn-link f-blue p-0" (click)="retry()">
          <i class="fa fa-mouse-pointer ml-1"></i>پشیمون شدم. آنلاین پرداخت میکنم
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="payment.Provider===PaymentProvider.Manual && payment.RemindDate">
      <div class="kp-message kp-message-info m-0">
        <div class="pointer float-left f-white" (click)="close()"><i class="fa fa-times"></i></div>
        <h5>یادآوری برای <span dir="ltr">{{payment.RemindDate|pdate:'[yy]/[mm]/[dd] [h]:[mi]'}}</span> ثبت شد</h5>
        <p>اون زمان اگر هنوز نیاز به استفاده از این خدمات داشتی، با تکمیل رویه پرداخت، سرویس رو فعال کن.</p>
      </div>
      <div class="text-left">
        <a class="btn btn-link f-blue" (click)="close()">پشیمون شدم. الان پرداخت میکنم</a>
      </div>
    </ng-container>

  </ng-container>
  <div class="kp-card orange-bg mx-0" *ngSwitchCase="1">
    <div class="pointer float-left f-white" (click)="close()"><i class="fa fa-times"></i></div>
    <div class="f-white">
      <h5>پرداخت تکمیل نشد.</h5>
      اگر مبلغی از حساب شما کسر شده باشد براساس فرایند بانک عامل شما به کارت شما بازگردانده می‌شود.
    </div>
    <ng-template [ngTemplateOutlet]="reasonTemplate||defaultReasonTemplate"></ng-template>
    <div class="text-center py-2 px-0">
      <button class="btn btn-primary ml-1" (click)="retry(true)">
        خطایی رخ داد! دوباره امتحان می‌کنم
      </button>
      <button *ngIf="!noManual" class="btn btn-secondary ml-1"
        (click)="failedReason='manual-payment';manualModal.open()">
        پرداخت از طریق کارت به کارت
      </button>
      <button class="btn pointer" (click)="close()">بازگشت</button>
    </div>
  </div>
  <div class="kp-card orange-bg f-white mx-0" *ngSwitchDefault>
    <h4>پرداخت تکمیل نشد.</h4>
    اگر مبلغی از حساب شما کسر شده باشد براساس فرایند بانک عامل شما به کارت شما بازگردانده می‌شود
  </div>
</div>

<ng-template #defaultReasonTemplate>
  <div class="border shadow-kp white-bg f-black p-1">
    <div class="mb-3">لطفا ما رو در جهت بهبود کیفیت خدمات یاری کنید و دلیل این رویداد رو برای ما مشخص کنید:</div>
    <label (click)="reasonInformationTemplate&&reasonModal.open()">
      <input type="radio" name="failed-reason" [checked]="failedReason=='information'"
        (change)="failedReason='information'">از خدمات اطلاع دقیقی ندارم
    </label>
    <label (click)="reasonExpensiveTemplate&&reasonModal.open()">
      <input type="radio" name="failed-reason" [checked]="failedReason=='expensive'"
        (change)="failedReason='expensive'">مبلغ در ازای خدمات مورد اشاره زیاد است
    </label>
    <label (click)="reasonModal.open()">
      <input type="radio" name="failed-reason" [checked]="failedReason=='password'"
        (change)="failedReason='password'">رمز دوم کارت بانکی ندارم
    </label>
  </div>
</ng-template>

<ngx-smart-modal #reasonModal identifier="reasonModal" [ngSwitch]="failedReason">
  <ng-template *ngSwitchCase="'information'" [ngTemplateOutlet]="reasonInformationTemplate"></ng-template>
  <ng-template *ngSwitchCase="'expensive'" [ngTemplateOutlet]="reasonExpensiveTemplate"></ng-template>

  <div *ngSwitchCase="'password'" class="container-capped-sm text-justify p-1">
    <h3>مراحل گرفتن رمز دوم بانکی</h3>
    <ol class="kp-ol">
      <li>مراجعه به نزدیکترین عابر بانک</li>
      <li>وارد کردن کارت بانکی</li>
      <li>انتخاب گزینه <span class="bank-button">تغییر رمز</span> یا <span class="bank-button">خدمات رمز</span></li>
      <li>انتخاب گزینه <span class="bank-button">رمز دوم</span> یا <span class="bank-button">رمز اینترنتی</span></li>
      <li>وارد کردن یک عدد ۵ تا ۱۲ رقمی به عنوان رمز دوم</li>
      <li>تکرار همان عدد وارد شده به عنوان تأیید</li>
      <li>دریافت برگه‌ی تایید که شامل کد CVV2 هست<br />
        اگر این کد روی کارت‌ت حک نشده بود، علاوه بر رمز اون کد رو هم حفظ کن</li>
    </ol>
  </div>
</ngx-smart-modal>

<app-manual-payment-modal #manualModal [amount]="payment?.Amount" (submitPayment)="retryManual($event)">
</app-manual-payment-modal>